import { FormControl, TextField } from '@mui/material';
import FieldInfo from 'app/common/components/field-info';
import Widget from 'app/common/components/widgets/widget';
import type { NumberWidgetHookProps } from './number-widget-hook';

export function NumberInput({
  label,
  error,
  value,
  isRequired,
  disabled,
  readOnly,
  handleChange,
  onBlur,
  description,
  step,
  min,
  max,
  id
}: NumberWidgetHookProps) {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      required={isRequired}
      error={Boolean(error)}
      disabled={Boolean(disabled) || Boolean(readOnly)}
    >
      <TextField
        size="small"
        type="number"
        label={label}
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        required={isRequired}
        error={Boolean(error)}
        disabled={Boolean(disabled) || Boolean(readOnly)}
        inputProps={{
          step,
          min,
          max,
          'data-testid': `${id}__input`
        }}
      />
      <FieldInfo description={description} error={error} />
    </FormControl>
  );
}

export function NumberWidget(props: NumberWidgetHookProps) {
  return (
    <Widget testId={props.id}>
      <NumberInput {...props} />
    </Widget>
  );
}
